import Network from 'infrastructure/js/modules/network';

const getLocales = function(){
  return Network.get('locales');
};

export default {getLocales};
